import { DialogDraggableHeaderModule } from './../../../shared/dialog-draggable-header/dialog-draggable-header.module';
import { SearchableAutocompleteModule } from './../../../shared/searchable-autocomplete/searchable-autocomplete.module';
import { FileUploadModule } from 'primeng/fileupload';
import { EcmPartsService } from './ecm-dialogs/ecm-parts/ecm-parts.service';
import { CgpConfirmationDialogModule } from './../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.module';
import { TableModule } from 'primeng/table';
import { ListboxModule } from 'primeng/listbox';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EcmComponent } from './ecm.component';
import { CgpAppCardModule } from '../../../shared/cgp-app-card/cgp-app-card.module';
import { DataTableModule } from '../../../shared/data-table/data-table.module';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { EcmService } from './ecm.service';
import { EcmNecReportsComponent } from './ecm-dialogs/ecm-nec-reports/ecm-nec-reports.component';
import { EcmNecCompleteDateComponent } from './ecm-dialogs/ecm-nec-reports/ecm-nec-complete-date/ecm-nec-complete-date.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { EcmReportsComponent } from './ecm-dialogs/ecm-reports/ecm-reports.component';
import { EcmToolChangeComponent } from './ecm-tool-change/ecm-tool-change.component';
import { EcmToolChangeService } from './ecm-tool-change/ecm-tool-change.service';
import { ToolPartRelationshipComponent } from './ecm-dialogs/tool-part-relationship/tool-part-relationship.component';
import { PartsByProgramComponent } from './ecm-dialogs/tool-part-relationship/parts-by-program/parts-by-program.component';
import { EcmPartsComponent } from './ecm-dialogs/ecm-parts/ecm-parts.component';
import { EcmPartsPartComponent } from './ecm-dialogs/ecm-parts/ecm-parts-part/ecm-parts-part.component';
import { EcmPartsAddProgramRelationComponent } from './ecm-dialogs/ecm-parts/ecm-parts-add-program-relation/ecm-parts-add-program-relation.component';
import { EcmPartsAddToolRelationComponent } from './ecm-dialogs/ecm-parts/ecm-parts-add-tool-relation/ecm-parts-add-tool-relation.component';
import { EcmPartsPartChangeComponent } from './ecm-dialogs/ecm-parts/ecm-parts-part-change/ecm-parts-part-change.component';
import { EcmPartsModifyPartChangeComponent } from './ecm-dialogs/ecm-parts/ecm-parts-modify-part-change/ecm-parts-modify-part-change.component';
import { EtcMultiRowUpdateComponent } from './ecm-tool-change/etc-multi-row-update/etc-multi-row-update.component';
import { EtcAuthoritiesComponent } from './ecm-tool-change/etc-authorities/etc-authorities.component';
import { EtcAddAuthorityComponent } from './ecm-tool-change/etc-authorities/etc-add-authority/etc-add-authority.component';
import { EcmPartsReportsComponent } from './ecm-dialogs/ecm-parts/ecm-parts-reports/ecm-parts-reports.component';
import { EcmPartsSupersedeComponent } from './ecm-dialogs/ecm-parts/ecm-parts-supersede/ecm-parts-supersede.component';
import { LoadingSpinnerModule } from 'src/app/shared/loading-spinner/loading-spinner.module';
import { EcmUploadPartsComponent } from './ecm-dialogs/ecm-upload-parts/ecm-upload-parts.component';
import { EtcEditToolChangeComponent } from './ecm-tool-change/etc-edit-tool-change/etc-edit-tool-change.component';

@NgModule({
    imports: [
        CommonModule,
        CgpAppCardModule,
        DataTableModule,
        MatButtonModule,
        MatDialogModule,
        FormsModule,
        TableModule,
        CheckboxModule,
        DropdownModule,
        ListboxModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatDividerModule,
        MatCheckboxModule,
        MatIconModule,
        MatSelectModule,
        MatOptionModule,
        ReactiveFormsModule,
        MatInputModule,
        MatSelectModule,
        MatCheckboxModule,
        MatRadioModule,
        MatCardModule,
        CgpConfirmationDialogModule,
        LoadingSpinnerModule,
        FileUploadModule,
        SearchableAutocompleteModule,
        DialogDraggableHeaderModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
    ],
    declarations: [
        EcmComponent,
        EcmToolChangeComponent,
        EcmNecReportsComponent,
        EcmNecCompleteDateComponent,
        EcmReportsComponent,
        ToolPartRelationshipComponent,
        PartsByProgramComponent,
        EcmPartsComponent,
        EcmPartsPartComponent,
        EcmPartsAddProgramRelationComponent,
        EcmPartsAddToolRelationComponent,
        EcmPartsPartChangeComponent,
        EcmPartsModifyPartChangeComponent,
        EtcMultiRowUpdateComponent,
        EtcAddAuthorityComponent,
        EcmPartsReportsComponent,
        EcmPartsSupersedeComponent,
        EtcAuthoritiesComponent,
        EcmUploadPartsComponent,
        EtcEditToolChangeComponent,
    ],
    providers: [
        EcmService,
        EcmToolChangeService,
        EcmPartsService
    ]
})
export class EcmModule { }
